import { LocalizedSurveyText, ScoreValueMapping, SurveyScore } from ".";

export const SurveyQuestionTypes = ['default', 'custom', 'multiple-choice'] as const;
export type SurveyQuestionType = typeof SurveyQuestionTypes[number];

type SurveyQuestionBase = {
    indicators: string[],
    title:string,
    translations:LocalizedSurveyText[],
    canComment: boolean,
    conditionalDisplay?: {
        triggerValues: string[],
    },
}

// ---------------------------------------------------

export type SurveyQuestionOption = 
{
    value:string,
    text:string,
    translations:LocalizedSurveyText[],
}

export type ScoredSurveyQuestionOption = 
    SurveyQuestionOption & { score:SurveyScore };

// ---------------------------------------------------

export const DefaultSurveyQuestionOptions:ScoredSurveyQuestionOption[] = [
    { value:'1', text:'Meget uenig', translations:[], score:1 },
    { value:'2', text:'Uenig', translations:[], score:2 },
    { value:'3', text:'Neutral', translations:[], score:3 },
    { value:'4', text:'Enig', translations:[], score:4 },
    { value:'5', text:'Meget enig', translations:[], score:5 }
];
export const DefaultScoreValueMapping: ScoreValueMapping[] = 
    [
        { value:'1', score:1 },
        { value:'2', score:2 },
        { value:'3', score:3 },
        { value:'4', score:4 },
        { value:'5', score:5 }
    ];

export type DefaultSurveyQuestionConfig = {
    type:'default',
    invertScore:boolean,
}

export type DefaultSurveyQuestion =
    SurveyQuestionBase & DefaultSurveyQuestionConfig

// ---------------------------------------------------

type UnscoredCustomSurveyQuestionConfig = {
    type:'custom',
    scored:false,
    options:SurveyQuestionOption[],
}

type ScoredCustomSurveyQuestionConfig = {
    type:'custom',
    scored:true,
    options:ScoredSurveyQuestionOption[],
}

export type CustomSurveyQuestionConfig =
    UnscoredCustomSurveyQuestionConfig |
    ScoredCustomSurveyQuestionConfig;

export type CustomSurveyQuestion =
    SurveyQuestionBase & CustomSurveyQuestionConfig;

// ---------------------------------------------------

export type MultipleChoiceSurveyQuestionConfig = {
    type:'multiple-choice',
    options:SurveyQuestionOption[],
}

export type MultipleChoiceSurveyQuestion =
    SurveyQuestionBase & MultipleChoiceSurveyQuestionConfig;

// ---------------------------------------------------

export type SurveyQuestionConfig =
    DefaultSurveyQuestionConfig |
    CustomSurveyQuestionConfig |
    MultipleChoiceSurveyQuestionConfig;

export type SurveyQuestion =
    DefaultSurveyQuestion |
    CustomSurveyQuestion |
    MultipleChoiceSurveyQuestion;